import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

// 1. Define the base styles and variants, now using tw-animate-css
const chatMessageVariants = cva(
  // Base classes applied to all messages
  // We replaced 'opacity-0 animate-fade-in' with the line below
 'my-3 max-w-[95%] rounded-[3em] px-8 py-6 text-base shadow-message select-text transition-opacity ease-in-out animate-in fade-in slide-in-from-bottom-4 duration-500 break-words mx-auto',
  {
    variants: {
      variant: {
        user: 'bg-user-message-bg text-center text-user-message-text',
        assistant: 'bg-ai-message-bg text-center text-ai-message-text',
        transparent: 'bg-transparent shadow-none border-none rounded-none px-4 py-2 text-center text-white text-2xl',
        bubble: 'bg-white/90 text-center text-gray-900 shadow-lg border border-gray-200',
      },
    },
    defaultVariants: {
      variant: 'assistant',
    },
  }
);

// ... The rest of the component remains exactly the same ...
export interface DEAIChatMessageProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof chatMessageVariants> {
  isFaded?: boolean;
}

const DEAIChatMessage = React.forwardRef<HTMLDivElement, DEAIChatMessageProps>(
  ({ className, variant, isFaded, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
            chatMessageVariants({ variant }),
            {
              'opacity-0 duration-[3000ms]': isFaded,
            },
            className
          )}
        {...props}
      />
    );
  }
);

export { DEAIChatMessage, chatMessageVariants };